<template>
    <div>
<!--&lt;!&ndash;      {{autoLoginToken}}&ndash;&gt;-->
<!--      {{organizationId}}{{localPersonalityData}}{{autoLoginToken}}-->
<!--      {{organizationIds}}{{autoLoginToken}}-->
    <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
      <vs-popup title="Feedback" fullscreen  :active.sync="show">
        <div class="iframe-container" v-if="organizationIds">
          <iframe
            :src="'https://gala.talentprint.com/users/manage_raters'+autoLoginToken"
            class="w-full h-full border-0"
            :key="userProgress"
            title="Feedback"
          >
          </iframe>
        </div>
        <div class="iframe-container" v-else>
          <iframe
            :src="'https://getboarded.talentprint.com/users/manage_raters'+localPersonalityData.personalityYoulabToken"
            class="w-full h-full border-0"
            :key="userProgress"
            title="Feedback"
          >
          </iframe>
        </div>
      </vs-popup>
      <vs-popup title="Career Lab Report" fullscreen :active.sync="CareerLabReport">
        <div class="iframe-container" v-if="organizationIds">
          <iframe
            :src="'https://gala.talentprint.com/profiles/view'+autoLoginToken"
            class="w-full h-full border-0"
            :key="userProgress"
            id="reportRld"
            title="Career Lab Report"
          >
          </iframe>
        </div>
        <div class="iframe-container" v-else>
          <iframe
            :src="'https://getboarded.talentprint.com/profiles/view'+localPersonalityData.personalityYoulabToken"
            class="w-full h-full border-0"
            id="reportRld"
            :key="userProgress"
            title="Personality Report "
          >
          </iframe>
        </div>
      </vs-popup>
      <div class="mb-base">
        <div class="flex justify-between flex-wrap mb-1">
          <div class="w-full lg:w-2/3 xl:w-2/3">
            <iframe v-if="organizationIds"
              :src="'https://gala.talentprint.com/'+autoLoginToken"
              class="w-full h-full border-0"
                    :key="userProgress"
              style="display:none;"
            >
            </iframe>
              <iframe v-else
                      :src="'https://getboarded.talentprint.com/'+localPersonalityData.personalityYoulabToken"
                      class="w-full h-full border-0"
                      :key="userProgress"
                      style="display:none;"
              >
            </iframe>
            <vs-row>
              <h3 class="float-left mr-4">{{ $t('editor.personality.title') }}</h3>
              <vx-tooltip
                v-if="saveInProgress"
                class="float-left mr-base"
                text="Saving to cloud..."
              >
                <feather-icon
                  icon="CloudIcon"
                  class="save-in-progress-status-icon"
                  svgClasses="text-success"
              /></vx-tooltip>
              <vx-tooltip v-else class="float-left mr-base" 
                :text="$t('editor.personality.saveToCloud')"
                ><feather-icon
                  icon="CloudIcon"
                  class="save-in-progress-status-icon"
              /></vx-tooltip>

              <!-- Personality Tour -->
              <v-tour
                name="personalityTour"
                :steps="personalityTourSteps"
                :callbacks="personalityTourCallbacks"
              ></v-tour>

              <vs-row class="personality-options" style="width: auto;">
                <!--- Reset All --->
                <vx-tooltip
                  class="mr-4"
                  text="Reset All"
                  position="bottom"
                  ><vs-button
                    id="pi-step-0"
                    :disabled="
                     !localPersonalityData.personalityTraits.length>0
                    "
                    @click.stop="resetPersonalityTraits()"
                    size="small"
                    color="primary"
                    type="flat"
                    icon-pack="material-icons"
                    icon="settings_backup_restore"
                  ></vs-button
                ></vx-tooltip>
                <!--- Only Reset Priority --->
                <vx-tooltip
                  class="mr-4"
                  text="Only Reset Priority"
                  position="bottom"
                  ><vs-button
                    id="pi-step-1"
                    :disabled="
                     !priorityStatus
                    "
                    @click.stop="onlyResetPriorityPersonalityTraits()"
                    size="small"
                    color="primary"
                    type="flat"
                    icon-pack="material-icons"
                    icon="low_priority"
                  ></vs-button
                ></vx-tooltip>
<!--                {{autoLoginToken}}-->
                <div v-if="organizationIds">

                  <vx-tooltip
                    class="mr-4"
                    v-if="autoLoginToken  && isUserLoggedIn"
                    text="Get Feedback"
                    position="bottom"
                  ><vs-button
                    id="pi-step-2"
                    size="small"
                    color="primary"
                    type="flat"
                    @click="feedback"
                    icon-pack="material-icons"
                    icon="supervisor_account"
                    :disabled="!(this.$store.state.boards.userBoardData.progress>0 && isUserLoggedIn)"
                  ></vs-button
                  ></vx-tooltip>
                </div>
                <div v-else>
                  <vx-tooltip
                    class="mr-4"
                    v-if="localPersonalityData.personalityYoulabToken  && isUserLoggedIn"
                    text="Get Feedback"
                    position="bottom"
                  ><vs-button
                    id="pi-step-2"
                    size="small"
                    color="primary"
                    type="flat"
                    @click="feedback"
                    icon-pack="material-icons"
                    icon="supervisor_account"
                    :disabled="!(localPersonalityData.personalityYoulabToken &&  localPersonalityData.personalityYoulabProgress>0 && isUserLoggedIn)"
                  ></vs-button
                  ></vx-tooltip>
                </div>


<!--                {{localPersonalityData.personalityYoulabToken}}-->
<!--                {{localPersonalityData.isUserLoggedIn}}-->
                <div v-if="organizationIds">
                <vx-tooltip
                  class="mr-4"
                  :text="this.$store.state.boards.userBoardData.progress===2?'Talent Discovery':'Report will be activated after a minimum 4 feedbacks are received\n'+
'\n'"
                  position="bottom"
                  v-if="autoLoginToken && isUserLoggedIn"
                >
                  <vs-button
                    id="pi-step-3"
                    size="small"
                    @click="personalityReport()"
                    color="primary"
                    type="flat"
                    icon-pack="material-icons"
                    icon="layers"
                    :disabled="!(this.$store.state.boards.userBoardData.progress===2 && isUserLoggedIn)"
                  ></vs-button
                  >
                </vx-tooltip>
                </div>
                <div v-else>
                  <vx-tooltip
                    class="mr-4"
                    :text="localPersonalityData.personalityYoulabProgress===2?'Personality':'Report will be activated after a minimum 4 feedbacks are received\n'+
'\n'"
                    position="bottom"
                    v-if="localPersonalityData.personalityYoulabToken && isUserLoggedIn"
                  >
                    <vs-button
                      id="pi-step-3"
                      size="small"
                      @click="personalityReport()"
                      color="primary"
                      type="flat"
                      icon-pack="material-icons"
                      icon="layers"
                      :disabled="!(localPersonalityData.personalityYoulabProgress===2 && isUserLoggedIn)"
                    ></vs-button
                    >
                  </vx-tooltip>
                </div>
<!--                <vx-tooltip-->
<!--                  class="mr-4"-->
<!--                  text="Career Lab "-->
<!--                  position="bottom"-->
<!--                >-->
<!--                <vs-button-->
<!--                  id="pi-step-3"-->
<!--                  size="small"-->
<!--                  @click="personalitySync()"-->
<!--                  color="primary"-->
<!--                  type="flat"-->
<!--                  icon-pack="material-icons"-->
<!--                  icon="layers"-->
<!--                ></vs-button-->
<!--                >-->
<!--                </vx-tooltip>-->

              </vs-row>

            </vs-row>
          </div>
          <div>
            <options
              :previousMove="{ name: 'editor-skills' }"
              :nextMove="{ name: 'editor-projects' }"
              @startPersonalityTour="startPersonalityTour"
            />
          </div>
        </div>
        <!-- <p v-if="!isUserLoggedIn" class="text-danger">
          You are not authenticated. Please login to save your data.
        </p>
        <p v-else-if="internetConnectionStatus">
          Internet Connection Active. Keep editing and your data gets auto-saved.
        </p>
        <p v-else class="text-danger">
          No Internet Connection. Please connect to Internet to save your data.
        </p> -->
        <p v-if="!isUserLoggedIn">
          <span v-if="organizationSlug === 'default'">
            {{ $t('editor.utils.notAuthenticated.youAreNotAuthenticated') }} <router-link :to="{ name: 'editor-about'}">{{ $t('editor.utils.notAuthenticated.login') }}</router-link> {{ $t('editor.utils.notAuthenticated.toSaveYourData') }}
          </span>
          <span v-else>
            {{ $t('editor.utils.notAuthenticated.youAreNotAuthenticated') }} <router-link :to="{ name: 'editor-about-custom'}">{{ $t('editor.utils.notAuthenticated.login') }}</router-link> {{ $t('editor.utils.notAuthenticated.toSaveYourData') }}
          </span>
        </p>
      </div>
      <div class="main-form">
        <h5 v-if="!best6Set" class="mb-2 text-dark">
          {{ $t('editor.personality.chooseYourTop6Strengths.p1') }}
          <span class="text-success"><b>{{ $t('editor.personality.chooseYourTop6Strengths.p2') }}</b></span> {{ $t('editor.personality.chooseYourTop6Strengths.p3') }}
        </h5>
        <div class="mb-3" v-else>
          <h5 class="mb-2 text-dark">
            {{ $t('editor.personality.characteristicsThatBestDescribeYou.p1') }}
            <span class="text-success"><b>{{ $t('editor.personality.characteristicsThatBestDescribeYou.p2') }}</b></span> {{ $t('editor.personality.characteristicsThatBestDescribeYou.p3') }}
          </h5>
          <!-- Assign Priority Number -->
          <vs-row
            v-if="Object.keys(personalityData).length"
            class="personality-row mb-2"
          >
            <vs-col
              v-for="(p, index) in localPersonalityData.personalityTraits"
              :key="index"
              vs-w="4"
              vs-xs="12"
            >
              <div v-if="index < 6">
                <div class="px-1 mb-2">
                  <vx-tooltip
                    :text="getPersonalityTraitById(p.id).description"
                    position="right"
                  >
                    <div @click.stop="pushPersonality(p.id)">
                      <vs-row
                        class="personality-unit"
                        :class="{
                          'personality-unit--selected': personalityTraitSelected(
                            p.id
                          ),
                        }"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="getPersonalityTraitById(p.id).pngIcon"
                              :alt="getPersonalityTraitById(p.id).title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="7"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <div class="personality-title">

                              {{ $t(getPersonalityTraitById(p.id).title) }}
                            </div>
                          </div>
                        </vs-col>
                        <vs-col
                          vs-w="2"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div v-if="p.priorityNumber" class="items-center">
                            <div class="personality-order">
                              {{ p.priorityNumber }}
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <div v-if="best6Set">
          <h5 v-if="!most6Set" class="mb-2 text-dark">
            {{ $t('editor.personality.choose6MoreStrengths.p1') }}
            <span class="text-primary"><b>{{ $t('editor.personality.choose6MoreStrengths.p2') }}</b></span> {{ $t('editor.personality.choose6MoreStrengths.p3') }}
          </h5>
          <div class="mb-3" v-else>
            <h5 class="mb-2 text-dark">
              {{ $t('editor.personality.characteristicsThatMostDescribeYou.p1') }}
              <span class="text-primary"><b>{{ $t('editor.personality.characteristicsThatMostDescribeYou.p2') }}</b></span> {{ $t('editor.personality.characteristicsThatMostDescribeYou.p3') }}
            </h5>
            <!--Assign Priority Number -->
            <vs-row
              v-if="Object.keys(personalityData).length"
              class="personality-row mb-2"
            >
              <vs-col
                v-for="(p, index) in localPersonalityData.personalityTraits"
                :key="index"
                vs-w="4"
                vs-xs="12"
              >
                <div v-if="index >= 6 && index < 12">
                  <div class="px-1 mb-2">
                    <vx-tooltip
                      :text="getPersonalityTraitById(p.id).description"
                      position="right"
                    >
                      <div @click.stop="pushPersonality(p.id)">
                        <vs-row
                          class="personality-unit--most"
                          :class="{
                            'personality-unit--selected-most': personalityTraitSelected(
                              getPersonalityTraitById(p.id).id
                            ),
                          }"
                          vs-align="center"
                          vs-type="flex"
                          vs-justify="center"
                        >
                          <vs-col
                            vs-w="3"
                            vs-type="flex"
                            vs-justify="center"
                            vs-align="center"
                          >
                            <span
                              class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                            >
                              <img
                                :src="getPersonalityTraitById(p.id).pngIcon"
                                :alt="getPersonalityTraitById(p.id).title"
                                width="24px"
                                height="24px"
                              />
                            </span>
                          </vs-col>
                          <vs-col
                            vs-w="7"
                            vs-type="flex"
                            vs-justify="left"
                            vs-align="left"
                          >
                            <div class="items-left">
                              <div class="personality-title">
                                {{ getPersonalityTraitById(p.id).title }}
                              </div>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="2"
                            vs-type="flex"
                            vs-justify="left"
                            vs-align="left"
                          >
                            <div v-if="p.priorityNumber" class="items-center">
                              <div class="personality-order">
                                {{ p.priorityNumber }}
                              </div>
                            </div>
                          </vs-col>
                        </vs-row>
                      </div>
                    </vx-tooltip>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
        <div class="mb-base">
          <h5 v-if="most6Set" class="mb-2 text-dark">
            {{ $t('editor.personality.characteristicsThatLeastDescribeYou.p1') }}
            <span class="text-warning"><b>{{ $t('editor.personality.characteristicsThatLeastDescribeYou.p2') }}</b></span> {{ $t('editor.personality.characteristicsThatLeastDescribeYou.p3') }}
          </h5>
          <!-- Assign Priority Number -->
          <vs-row
            v-if="Object.keys(personalityData).length"
            class="personality-row mb-4"
          >
            <vs-col
              v-for="(p, index) in sortedPersonalityData"
              :key="index"
              vs-w="4"
              vs-xs="12"
            >
              <div v-if="index < 6 && !best6Set">
                <div class="px-1 mb-2">
                  <vx-tooltip :text="getPersonalityTraitById(p.id).description" position="right">
                    <div @click.stop="pushPersonality(p.id)">
                      <vs-row
                        class="personality-unit cursor-pointer"
                        :class="{
                          'personality-unit--selected': personalityTraitSelected(
                            p.id
                          ),
                        }"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="9"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <!-- recheck -->
                            <div class="personality-title">{{ getPersonalityTraitById(p.id).title }}</div>
                          </div>
                        </vs-col>
                        <!-- <vs-col
                          vs-w="2"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div v-if="personalityTraitSelected(p.id)" class="items-center">
                            <div class="personality-order">{{ parseInt(index) + 1 }}</div>
                          </div>
                        </vs-col> -->
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
              <div v-else-if="index >= 6 && index < 12 && !most6Set">
                <div class="px-1 mb-2">
                  <vx-tooltip :text="getPersonalityTraitById(p.id).description" position="right">
                    <div @click.stop="pushPersonality(p.id)">
                      <vs-row
                        class="personality-unit cursor-pointer"
                        :class="{
                          'personality-unit--most': best6Set,
                          'personality-unit--selected': personalityTraitSelected(
                            p.id
                          ),
                          'personality-unit--selected-most':
                            best6Set && personalityTraitSelected(p.id),
                        }"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="9"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <div class="personality-title">{{ getPersonalityTraitById(p.id).title }}</div>
                          </div>
                        </vs-col>
                        <!-- <vs-col
                          vs-w="2"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div v-if="personalityTraitSelected(p.id)" class="items-center">
                            <div class="personality-order">{{ parseInt(index) + 1 }}</div>
                          </div>
                        </vs-col> -->
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
              <div v-else-if="index >= 12">
                <div class="px-1 mb-2">
                  <vx-tooltip :text="getPersonalityTraitById(p.id).description" position="right">
                    <div @click.stop="pushPersonality(p.id)">
                      <vs-row
                        class="personality-unit cursor-pointer"
                        :class="{
                          'personality-unit--most': best6Set && !most6Set,
                          'personality-unit--least': most6Set,
                        }"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="7"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <div class="personality-title">
                              {{ getPersonalityTraitById(p.id).title }}
                            </div>
                          </div>
                        </vs-col>
                        <vs-col
                          vs-w="2"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div
                            v-if="getCurrentPriorityNumber(p.id)"
                            class="items-center"
                          >
                            <div class="personality-order">
                              {{ getCurrentPriorityNumber(p.id) }}
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <vs-row class="mb-3">
              <label>{{ $t('editor.personality.keepBuildingYourPersonalBrand') }}</label>
            </vs-row>
            <vs-row class="mb-2">
              <vs-radio
                class="mr-3"
                name="Dont Broadcast my personality"
                v-model="localPersonalityData.broadcastPersonality"
                vs-value="dont-broadcast-my-personality"
                @blur="saveField('saveBroadcastPersonality')"
                :disabled="disableInputField"
              >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonality ===
                      'dont-broadcast-my-personality',
                  }"
                >
                  {{ $t('editor.personality.dontBroadcastMyPersonality') }}
                </span>
              </vs-radio>
            </vs-row>
            <vs-row class="mb-2">
              <vs-radio
                class="mr-3"
                name="Show personality statements"
                v-model="localPersonalityData.broadcastPersonality"
                vs-value="show-personality-statements"
                @blur="saveField('saveBroadcastPersonality')"
                :disabled="disableInputField"
              >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonality ===
                      'show-personality-statements',
                  }"
                >
                  {{ $t('editor.personality.statements') }}
                </span>
              </vs-radio>
              <vs-radio
                class="mr-3"
                name="Show cloud tag"
                v-model="localPersonalityData.broadcastPersonality"
                vs-value="show-cloud-tag"
                @blur="saveField('saveBroadcastPersonality')"
                :disabled="disableInputField"
              >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonality ===
                      'show-cloud-tag',
                  }"
                >
                  {{ $t('editor.personality.cloudTags') }}
                </span>
              </vs-radio>
              <vs-radio
                class="mr-3"
                name="Show icons"
                v-model="localPersonalityData.broadcastPersonality"
                vs-value="show-icons"
                @blur="saveField('saveBroadcastPersonality')"
                :disabled="disableInputField"
              >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonality ===
                      'show-icons',
                  }"
                >
                  {{ $t('editor.personality.icons') }}
                </span>
              </vs-radio>
            </vs-row>
          </div>
          <div class="vx-col w-full md:w-1/2">
            <label class="flex items-center">
              {{ $t('editor.personality.personalityStatements') }}
              <vx-tooltip
                text="These are some guidelines on how to communicate your personality type. These are editable to give you freedom to express your own version of it."
                position="top"
                style="display: flex; align-items: baseline;"
                class="items-center ml-2"
              >
                <feather-icon icon="InfoIcon" class="w-4 h-4" />
              </vx-tooltip>
            </label>
            <vs-textarea
              class="w-full"
              height="100px"
              name="Personality Statements"
              :disabled="disableInputField"
              v-model="localPersonalityData.personalityStatements"
              @blur="saveField('savePersonalityStatements')"
            />
          </div>
        </div>
      </div>
    <!-- </vue-perfect-scrollbar> -->
    </div>
</template>

<script>
// import FeatherIcon from "../../components/FeatherIcon.vue";
import Options from "../components/Options.vue";
import constants from "@/constants";
import axios from '@/axios.js';
import { successNotifyService, failureNotifyService } from "@/services/errors.service.js";

import { saveInputFieldService } from "@/services/editor/personality.service.js";
// import personalityData from "@/assets/data/personality.js";
// import _ from "lodash";

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: { Options, VuePerfectScrollbar },
  name: "EditorPersonality",
  props: ["personalityData"],
  data() {
    return {
      localData: {},
      localPersonalityData: {},
      personalityId:[],
      organizationIds:"",
      idData:[],
      idDataAll:[],
      personalityYoulabToken:null,
      answers:[],
      constants,
      show:false,
      priorityStatus:false,
      youlabIdcheck:false,
      CareerLabReport:false,
      aboutSectionCheck:false,
      youlbTokenCheck:false,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 40,
        wheelSpeed: 0.6,
      },
      // personalityData: this.shufflePersonalityData(personalityData),
      sortedPersonalityData: this.personalityData,
      personalityTourSteps : [
        {
            target: '#pi-step-0',
            header: {
              title: 'Reset All',
            },
            content: `Clear all your characteristics and make a self assessment again.`
        },
        {
            target: '#pi-step-1',
            header: {
              title: 'Only Reset Priority',
            },
            content: `Reset Development Priority and add behaviours that you wish to develop.`
        },
        {
            target: '#pi-step-2',
            header: {
              title: 'Get Feedback',
            },
            content: `Gather positive feedback from peers to validate your personality type. A quick 2 step form to assess how people see your personality.`
        },
        {
            target: '#pi-step-3',
            header: {
              title: 'Career Lab',
            },
            content: `Competency Report to discover your hidden strengths and blind spots.`
        },
      ],
      personalityTourCallbacks: {
        onPreviousStep: this.personalityTourPreviousStep,
        onNextStep: this.personalityTourNextStep,
        onFinish: this.personalityTourFinish,
        onSkip: this.personalityTourSkip
      },
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    personality() {
      return this.$store.state.editor.personality;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    best6Set() {
      if (this.localPersonalityData.personalityTraits) {
        if (this.localPersonalityData.personalityTraits.length >= 6) {
          return true;
        }
      }
      return false;
    },
    most6Set() {
      if (this.localPersonalityData.personalityTraits) {
        if (this.localPersonalityData.personalityTraits.length >= 12) {
          // this.startPersonalityTour();
          return true;
        }
      }
      return false;
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    autoLoginToken() {
      console.log('this.$store.state.boards.userBoardData',this.$store.state.boards.userBoardData.progress);
      return this.$store.state.boards.userBoardData.youlabToken;
    },
    activateFeedback() {
      return this.autoLoginToken && this.userProgress >= 1;
    },
    activateCompetency() {

      return this.autoLoginToken && this.userProgress >= 2;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },

  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        //// console.log(newVal);
        this.localData = JSON.parse(JSON.stringify(newVal));
      }
    },
    personality(newVal) {
      if (newVal) {
        // // console.log(newVal);
        this.localPersonalityData = JSON.parse(JSON.stringify(newVal));
      }
    },
    localPersonalityData(newVal) {
      if (newVal) {
        // // console.log(newVal);
        this.sortedPersonalityData = this.sortPersonalityData();
        // // console.log(this.sortedPersonalityData);
      }
    },

    // most6Set(newVal) {
    //   console.log(newVal, 'most6set');
    //   if(newVal === true) {
    //     console.log('1234');
    //     this.startPersonalityTour();
    //   }
    // },
    // $tours(newVal) {
    //   console.log(newVal, 'tour');
    //   if(this.most6Set) {
    //     this.startPersonalityTour();
    //   }
    // }
  },
  methods: {
    startPersonalityTour() {
      console.log('start tour #######');
      if(this.$route.name.includes('editor-personality') && localStorage.getItem('personalityTour') !== 'finished' && localStorage.getItem('personalityTour') !== 'skipped') {
        // console.log(this.$tours);
        if(this.$tours['personalityTour']) {
          this.$tours['personalityTour'].start();
        }
      }
    },
    personalityTourPreviousStep (currentStep) {

    },
    personalityTourNextStep (currentStep) {

    },
    personalityTourFinish (currentStep) {
      localStorage.setItem('personalityTour', 'finished');
    },
    personalityTourSkip (currentStep) {
      localStorage.setItem('personalityTour', 'skipped');
    },
    feedback(){
      this.show=true;
    },
    shufflePersonalityData(array) {
      let currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    resetPersonalityTraits() {
      this.localPersonalityData.personalityTraits = [];
      this.personalityId=[];
      this.idDataAll=[];
      this.idBestData=[];
      this.idMostData=[];
      this.idLeastData=[];
      this.mergeData=[];
      this.answers=[];
      this.priorityStatus=false;
      this.saveField("savePersonalityTraits");
      this.localPersonalityData.personalityStatements = null;
      this.saveField("savePersonalityStatements");
    },
    onlyResetPriorityPersonalityTraits() {
      if (this.localPersonalityData.personalityTraits) {

        this.localPersonalityData.personalityTraits.forEach((pt) => {
          delete pt.priorityNumber;
          this.priorityStatus=false;
        });

        this.saveField("savePersonalityTraits");
      } else {
        return;
      }
    },
    personalityReport(){
      this.CareerLabReport=true;
      document.getElementById('reportRld').src = document.getElementById('reportRld').src
    },
    // personalitySync(){
    //   console.log(this.usersData);
    //   if(this.usersData.firstName){
    //     let youlabTokenApiData ={
    //       email: this.usersData.email,
    //       first_name: this.usersData.firstName,
    //       last_name:this.usersData.lastName,
    //       _id:this.personality._id,
    //       flag:"youlabTokenGenerate"
    //     };
    //     this.$store
    //       .dispatch("editor/updatePersonality",youlabTokenApiData)
    //       .then(res =>{
    //         const payload = {
    //           title: "Career Lab",
    //           text: "Career Lab Successfully Created",
    //           currentThis: this
    //         }
    //         successNotifyService(payload);
    //         window.location.reload();
    //         // console.log(res);
    //       })
    //       .catch((err) => {
    //         throw err;
    //       })
    //   }else{
    //     const payload = {
    //       title: "Career Lab",
    //       text: "Please Complete About Section",
    //       currentThis: this
    //     }
    //     failureNotifyService(payload);
    //   }
    //   if(this.personality.personalityYoulabToken){
    //
    //   }else{
    //     this.youlbTokenCheck=true
    //   }
    // //
    // },

    getPersonalityTraitById(id) {
      const p = this.personalityData.find((pd) => pd.id === id);
      return p;
    },
    getCurrentPriorityNumber(id) {

      if (this.localPersonalityData.personalityTraits) {
        let cpObj = this.localPersonalityData.personalityTraits.find(
          (pt) => pt.id === id
        );
        if (cpObj) {
          this.priorityStatus=true;
          return cpObj.priorityNumber;
        }
        return null;
      }
      return null;
    },
    getNextPriorityNumber() {
      let pn = 0;
      this.localPersonalityData.personalityTraits.forEach((p) => {
        if (p.priorityNumber > 0) pn = pn + 1;this.priorityStatus=true;

      });
      return pn + 1;
    },
    sortPersonalityData() {
      // if(this.most6Set) return;

      let allPData = this.personalityData;
      let selectedPData = this.localPersonalityData.personalityTraits;

      if (!Object.keys(allPData).length) return [];
      allPData = JSON.parse(JSON.stringify(allPData));

      if (!this.isUserLoggedIn) return allPData;

      if (!selectedPData || !selectedPData.length) return allPData;
      selectedPData = JSON.parse(JSON.stringify(selectedPData));

      let sortedData = [];
      let unSelectedData = [];

      selectedPData.forEach((sp) => {
        let spo = Object.keys(allPData).find((p) => {
          return allPData[p].id === sp.id;
        });
        sortedData.push(allPData[spo]);
      });

      let arrOfIds = [];
      selectedPData.forEach((sd) => {
        arrOfIds.push(sd.id);
      });

      Object.keys(allPData).forEach((ap) => {
        if (!arrOfIds.includes(allPData[ap].id)) {
          // // console.log(allPData[ap]);
          unSelectedData.push(allPData[ap]);
        }
      });

      sortedData = sortedData.concat(unSelectedData);

      // // console.log(sortedData);
      return sortedData;
    },
    personalityTraitSelected(id) {
      if (this.localPersonalityData.personalityTraits) {
        let arrOfIds = [];
        this.localPersonalityData.personalityTraits.forEach((sd) => {
          arrOfIds.push(sd.id);
        });
        return arrOfIds.includes(id);
      } else {
        return false;
      }
    },
    pushPersonality(id) {
      // // console.log(id, this.localPersonalityData);

      // // console.log(id);

      if (!this.isUserLoggedIn || !this.internetConnectionStatus) return;

      if (this.most6Set && this.getPersonalityTraitById(id).priorityNumber > 0)
        return;

      // if (this.most6Set) return;
      // // console.log("push");
      if(!this.localPersonalityData.personalityTraits) {
          this.localPersonalityData.personalityTraits = [];
      }
      const pIndex = this.localPersonalityData.personalityTraits.findIndex(
        (pI) => pI.id === id
      );

      // // console.log(pIndex);

      // best, most & least not selected
      if (!this.most6Set) {
        if (pIndex === -1) {
          this.localPersonalityData.personalityTraits.push({ id });

          // Set personality statements
          // if(this.localPersonalityData.personalityTraits.length < 7) {
          //   const self = this;
          //   self.localPersonalityData.personalityStatements = "";
          //   this.localPersonalityData.personalityTraits.forEach(pt => {
          //     self.localPersonalityData.personalityStatements += self.getPersonalityTraitById(pt.id).iAmDescription + '\n';
          //     //  Personality  youLabMap Id
          //     this.personalityId.push(self.getPersonalityTraitById(pt.id).personalityMapId);
          //   });
          //   this.personalityYoulabData = [...new Set(this.personalityId)];
          //   if (this.personalityYoulabData.length == 6) {
          //     for (let i = 1; i <= 18; i++) {
          //       for (let j = 0; j < this.personalityYoulabData.length; j++) {
          //         if (i === this.personalityYoulabData[j]) {
          //           this.idData[i] = 2;
          //         }
          //       }
          //       this.idDataAll[i] = 0;
          //     }
          //
          //   //// console.log(this.idDataAll,this.idData);
          //
          //   // Object Array Merge
          //   this.answers = JSON.parse(JSON.stringify(Object.assign({}, this.idDataAll, this.idData)));
          //  //   console.log('organizationId',this.organizationId);
          //     let youlabData ='';
          //     if(this.organizationIds){
          //        youlabData =
          //         {
          //           "_id": this.personality._id,
          //           "answers": this.answers,
          //           "user_id": this.$store.state.boards.userBoardData.youlabId,
          //           "flag": "talentPrintIdSync",
          //           'youlabToken': this.$store.state.boards.userBoardData.youlabToken,
          //           'progress': this.$store.state.boards.userBoardData.progress,
          //           'board_user_id': this.$store.state.boards.userBoardData._id,
          //         }
          //       this.$store
          //         .dispatch("editor/updatePersonality",youlabData)
          //         .then(res =>{
          //           // console.log(res);
          //           this.$store
          //             .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id ).then(res=>{
          //           }) .catch((err) => {
          //             throw err;
          //           })
          //         })
          //         .catch((err) => {
          //           throw err;
          //         })
          //     }else{
          //        youlabData =
          //         {
          //           "_id": this.personality._id,
          //           "answers": this.answers,
          //           "user_id": this.personality.personalityYoulabId,
          //           "flag": "getboardedYoulabIdSync",
          //           'youlabToken': this.personality.personalityYoulabToken,
          //           'progress': this.personality.personalityYoulabProgress,
          //         }
          //       this.$store
          //         .dispatch("editor/updatePersonality",youlabData)
          //         .then(res =>{
          //           // console.log(res);
          //           // this.$store
          //           //   .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id ).then(res=>{
          //           // }) .catch((err) => {
          //           //   throw err;
          //           // })
          //         })
          //         .catch((err) => {
          //           throw err;
          //         })
          //     }
          // }
          //   this.saveField('savePersonalityStatements');
          // }

          // Best 6 selected
          if (this.localPersonalityData.personalityTraits.length === 6) {
            if(this.localPersonalityData.personalityTraits.length < 7) {
              const self = this;
              self.localPersonalityData.personalityStatements = "";
              this.localPersonalityData.personalityTraits.forEach(pt => {
                self.localPersonalityData.personalityStatements += self.getPersonalityTraitById(pt.id).iAmDescription + '\n';
                //  Personality  youLabMap Id
                this.personalityId.push(self.getPersonalityTraitById(pt.id).personalityMapId);
              });
              this.personalityYoulabData = [...new Set(this.personalityId)];
              for(let n = 1; n <= 18; n++) {
                this.answers[n]=0;
              }
              if (this.personalityYoulabData.length === 6) {
                for (let i = 1; i <= 18; i++) {
                  for (let j = 0; j < this.personalityYoulabData.length; j++) {
                    if (i === this.personalityYoulabData[j]) {
                      this.idBestData[i] = 2;
                    }
                  }
                }

                //// console.log(this.idDataAll,this.idData);

                // Object Array Merge

              }
              this.saveField('savePersonalityStatements');
            }
            this.$vs.notify({
              title:
                "Choose 6 more strengths",
              text:
                "Choose 6 more strengths (Characteristics that MOST describe you)",
              fixed: false,
            });
          }

          // Most 6 selected
          if (this.localPersonalityData.personalityTraits.length === 12) {
            if(this.localPersonalityData.personalityTraits.length < 13) {
              const self = this;
              self.localPersonalityData.personalityStatements = "";
              this.localPersonalityData.personalityTraits.forEach(pt => {
                self.localPersonalityData.personalityStatements += self.getPersonalityTraitById(pt.id).iAmDescription + '\n';
                //  Personality  youLabMap Id
                this.personalityId.push(self.getPersonalityTraitById(pt.id).personalityMapId);
              });
              this.personalityYoulabData = [...new Set(this.personalityId)];
              if (this.personalityYoulabData.length === 12) {
                for (let i = 1; i <= 18; i++) {
                  for (let j = 6; j < this.personalityYoulabData.length; j++) {
                    if (i === this.personalityYoulabData[j]) {
                      this.idMostData[i] = 1;
                    }
                  }
                }

                //// console.log(this.idDataAll,this.idData);

                // Object Array Merge
                this.answers = JSON.parse(
                  JSON.stringify(Object.assign({}, this.answers,this.idBestData, this.idMostData))
                );
                //   console.log('organizationId',this.organizationId);
                let youlabData ='';
                if(this.organizationIds){
                  youlabData =
                    {
                      "_id": this.personality._id,
                      "answers": this.answers,
                      "user_id": this.$store.state.boards.userBoardData.youlabId,
                      "flag": "talentPrintIdSync",
                      'youlabToken': this.$store.state.boards.userBoardData.youlabToken,
                      'progress': this.$store.state.boards.userBoardData.progress,
                      'board_user_id': this.$store.state.boards.userBoardData._id,
                    }
                  this.$store
                    .dispatch("editor/updatePersonality",youlabData)
                    .then(res =>{
                      // console.log(res);
                      this.$store
                        .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id ).then(res=>{
                      }) .catch((err) => {
                        throw err;
                      })
                    })
                    .catch((err) => {
                      throw err;
                    })
                }else{
                  youlabData =
                    {
                      "_id": this.personality._id,
                      "answers": this.answers,
                      "user_id": this.personality.personalityYoulabId,
                      "flag": "getboardedYoulabIdSync",
                      'youlabToken': this.personality.personalityYoulabToken,
                      'progress': this.personality.personalityYoulabProgress,
                    }
                  this.$store
                    .dispatch("editor/updatePersonality",youlabData)
                    .then(res =>{
                      this.$vs.notify({
                        title:
                          "Would you like to develop any personality characteristic on Priority?",
                        text:
                          "Mark the behaviors that you would like to develop and get microlearning content feed on your development charter.",
                        fixed: true,
                      });
                    })
                    .catch((err) => {
                      throw err;
                    })
                }
              }
              this.saveField('savePersonalityStatements');
            }

          }
        } else {
          return;
        }
      } else {
        this.$store
          .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id ).then(res=>{
        }) .catch((err) => {
          throw err;
        })
        if (pIndex === -1) {
          this.localPersonalityData.personalityTraits.push({
            id,
            priorityNumber: this.getNextPriorityNumber(),
          });
        } else if (
          !this.localPersonalityData.personalityTraits[pIndex].priorityNumber
        ) {
          this.localPersonalityData.personalityTraits[pIndex][
            "priorityNumber"
          ] = this.getNextPriorityNumber();
        } else {
          return;
        }
      }

      this.saveField("savePersonalityTraits");
    },
    async saveField(action, fieldName = null) {
      let fieldIsValid = false;

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      // // console.log(this.localPersonalityData);

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        localPersonalityData: this.localPersonalityData,
        userId: this.userId,
        currentThis: this,
      };

      saveInputFieldService(payload);
    },
  },
  created() {
    this.$vs.loading;
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);
    this.sortedPersonalityData = this.sortPersonalityData();
    //youlabToken Set On Board Label
    this.$vs.loading.close();
    if (this.isUserLoggedIn) {
      this.$store
        .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id).then(res=>{
          if(res.data) {
            console.log('res.data.boardData.organizationId;',res.data.data[0].boardData.organizationId);
            this.organizationIds =res.data.data[0].boardData.organizationId;
          }
      }) .catch((err) => {
        throw err;
      })
      if(!this.autoLoginToken){
        this.autoLoginToken = this.$route.params.token;
      }
      if (this.usersData && Object.keys(this.usersData).length) {
        this.localData = JSON.parse(JSON.stringify(this.usersData));
        //// console.log(this.localData);
      }
      if (this.personality && Object.keys(this.personality).length) {
        this.localPersonalityData = JSON.parse(
          JSON.stringify(this.personality)
        );
      }
    }
  },
  mounted() {
    if(this.$route.name.includes('editor-personality') && localStorage.getItem('personalityTour') !== 'finished' && localStorage.getItem('personalityTour') !== 'skipped') {
      // console.log(this.$tours);
      if(this.$tours['personalityTour']) {
        this.$tours['personalityTour'].start();
      }
    }
    if (this.isUserLoggedIn) {
      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          const data = {
            flag: "youlabPersonalityProgress",
            _id: res.data.personality[0]._id,
            user_id: res.data.personality[0].personalityYoulabId,
            progress: res.data.personality[0].personalityYoulabProgress,
          };
          this.$store
            .dispatch("editor/updatePersonality", data)
            .then((res) => {
              this.$store
                .dispatch("users/fetchUser", this.$store.state.auth.user._id)
                .then((res) => {
                  this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
                })
              .catch();
            }).catch();
        }).catch();
    }
  }
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 615px;
  /*height: 1000px;*/
}
.personality-unit {
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  border-radius: 6px;
}

.personality-unit:hover {
  background: rgba(96, 191, 25, 0.06);
  border: 1px solid #60bf19;
  cursor: pointer !important;
}

.personality-unit--most {
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  border-radius: 6px;
}

.personality-unit--most:hover {
  background: rgba(242, 147, 0, 0.06) !important;
  border: 1px solid #f29300 !important;
  cursor: pointer !important;
}

.personality-unit--least:hover {
  background: #ffffff !important;
  border: 1px solid #f4f4f4 !important;
  cursor: pointer !important;
}

.personality-unit--selected {
  background: rgba(96, 191, 25, 0.06);
  border: 1px solid #60bf19;
}

.personality-unit--selected-most {
  background: rgba(242, 147, 0, 0.06) !important;
  border: 1px solid #f29300 !important;
}

.personality-title {
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  color: #414040;
}

.personality-order {
  background: #f29200;
  box-shadow: 0px 4px 8px rgba(255, 172, 46, 0.29);
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  color: white;
}

.text-personality-style {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: #7c7c7c;

  flex: none;
  order: 1;
  flex-grow: 0;
}

.broadcast-personality-selected {
  color: #f29300;
}

/*.vs-con-textarea >>> .vs-textarea {
  height: 90px !important;
}*/

.moving-item {
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
}

/*.vs-con-textarea >>> .vs-textarea {
  height: auto !important;
}*/

.personality-options >>> .vs-icon {
  font-weight: 900 !important;
  font-size: 20px !important;
  /*border: none;*/
}
.iframe-container {
  height: 100vh;
}

.v-tour >>> .v-step__button.v-step__button-skip {
  display: none!important;
}
</style>
